import React from 'react';
import { Routes, Route } from "react-router-dom";
import { useSelector } from 'react-redux';

import LoginForm from '../zeon-react-ui/auth/form';
import DashBoard from "./dashboard";

import { useAuth } from "../zeon-react-ui/auth/model";
import { AuthProvider, AuthRequired } from "../zeon-react-ui/auth/model";

const trademark = <b>&copy; {(new Date()).getFullYear()} DALBELLO SRL</b>
const Bootstrap = () => {
  const auth = useAuth();
  //if (auth) auth.api("/api/bootstrap");
  const logo = <img src="/dalbello.png" alt="DalBello srl" width="200px" height="auto" />
  return (
    <AuthProvider>
      <Routes>
        <Route path="/*" element={<AuthRequired><DashBoard /></AuthRequired>} />
        <Route path="login" element={<LoginForm api="/api/users/login" logo={logo} trademark={trademark} rememberLabel=""/>} />
      </Routes >
    </AuthProvider >
  );
}



export default Bootstrap;
